import type { ReactNode } from 'react';
import ReactMarkdown from 'react-markdown';

export const parseInlineMarkdown = (text: string): ReactNode => {
  return (
    <ReactMarkdown
      allowedElements={['p', 'strong', 'em']}
      unwrapDisallowed
      components={{
        p: ({ children }: { children?: ReactNode }) => <>{children}</>,
      }}
    >
      {text}
    </ReactMarkdown>
  );
};
